<template>
  <div v-if="getMe">
    <UseLandscapeMode v-show="showLandScapeSuggestedMessage"/>

    <div v-if="!showLandScapeSuggestedMessage">
      <div class="edit-header">
        <nav class="navbar navbar-expand-lg navbar-light  ">
          <a class="navbar-brand"> {{ formattedTime }} </a>

          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav  mr-auto">
              <li class="nav-item "
                  :class="view === 'company' ? 'active '  : ''  ">
                <a
                    href="javascript:;"
                    @click="view = 'company'"
                    class="nav-link "
                >
                  {{ getCompanyName }}
                </a>
              </li>
              <li class="nav-item"
                  :class="view === 'personal' ? 'active '  : ''  "
              >
                <a
                    href="javascript:;"
                    @click="view = 'personal'"
                    class="nav-link "
                >
                  {{ $t('insights.myView') }}
                </a>
              </li>
            </ul>
            <form @submit.prevent="" class="form-inline my-5 my-lg-0"
                  v-if="getClaims.admin && view =='company' || view !='company' ">
              <button class="btn btn-success   float-right  ml-2 " @click="saveLayout"><i style="font-size:20px"
                                                                                          class="fal fa-save"></i>
              </button>
              <button class="btn btn-primary  btn-outline-primary float-right  ml-2 " @click="setEditingMode()"><i
                  class="fas fa-edit"></i>
                {{ !editing ? $t('insights.startEditing') : $t('insights.stopEditing') }}
              </button>
              <button class="btn btn-success ml-2  float-right" v-if="editing" @click="addNewGridItem"> {{
                  $t('insights.addNewChart')
                }}
              </button>
            </form>
          </div>
        </nav>

      </div>
      <grid-layout
          :layout.sync="layout"
          :col-num="colNum"
          :row-height="30"
          :is-draggable="editing"
          :is-resizable="editing"
          :responsive="true"
          :is-mirrored="false"
          :vertical-compact="true"
          :margin="[10, 10]"
          :use-css-transforms="true"

      >


        <grid-item v-for="(item,index) in layout"
                   :x="item.x"
                   :y="item.y"
                   :w="item.w"
                   :h="item.h"
                   :i="item.i"
                   :class="'grid-item-'+index"
                   :min-h="5"
                   :min-w="4"
                   drag-ignore-from=".no-drag"
                   :key="item.i">

          <span v-if=editing class="remove" @click="removeItem(item.i)">         <i class="far fa-trash-alt"></i>         </span>

          <component
              v-if="item.component"
              :is="item.component"
              style="position: relative;  height: 100%;
              width: 100%"
              :editing=editing
              :index="item.i"
              :savedConfig="item.config"
              @configChanged="saveComponentConfig($event,item.i)"
          />
          <div v-if="!item.component" class="component-selector">
            <select class=form-control @change="setItemComponent($event,index)">
              <option value="null" disabled selected> Select Type of chart</option>
              <option value="Planning">Planning</option>
              <option value="JobsFilterBy">JobsFilterBy</option>
              <option value="DownTimePareto">DownTimePareto</option>
              <option value="DownTimeFilterdOnReason">DownTimeFilterdOnReason</option>
              <option value="DownTimeFilterdOnReason">DownTimeFilterdOnReason</option>
              <option value="JobProgress">JobProgress</option>
              <option value="ProducedPerActivity">ProducedPerActivity</option>
              <option value="BooleanCount">BooleanCount</option>
              <option value="CustomDateChart">CustomDateChart</option>
            </select>
          </div>

        </grid-item>

      </grid-layout>
    </div>
  </div>
</template>

<script>

// https://jbaysolutions.github.io/vue-grid-layout/guide/properties.html
import VueGridLayout from 'vue-grid-layout';


import Planning from '@/components/insights/Planning'
import JobsFilterBy from "@/components/insights/JobsFilterBy";
import DownTimePareto from "@/components/insights/DownTimePareto";
import JobLogs from "@/components/insights/JobLogs";
import DownTimeFilterdOnReason from "@/components/insights/DownTimeFilterdOnReason";
import HeartbeatHardwareLogs from "@/components/insights/HeartbeatHardwareLogs";
import JobProgress from "@/components/insights/JobProgress";
import ProducedPerActivity from "@/components/insights/ProducedPerActivity";
import {mapGetters} from "vuex";
import UseLandscapeMode from "@/components/UseLandscapeMode";
import BooleanCount from "@/components/insights/BooleanCount";
import CustomDateChart from "@/components/insights/CustomDateChart";

export default {
  name: "Insights",
  components: {
    ...VueGridLayout,
    Planning,
    JobsFilterBy,
    JobLogs,
    DownTimePareto,
    DownTimeFilterdOnReason,
    JobProgress,
    HeartbeatHardwareLogs,
    UseLandscapeMode,
    ProducedPerActivity,
    BooleanCount,
    CustomDateChart
  },
  data() {
    return {
      view: 'company',
      editing: false,
      layout: [],
      responsive: true,
      responsiveLayouts: true,
      isDraggable: true,
      isResizeable: true,
      autoSize: true,
      colNum: 12,
      dataChanged: false

    }
  },
  computed: {
    ...mapGetters(['getTime']),
    ...mapGetters('users', ['getClaims']),
    ...mapGetters('userData', ['getMe']),
    ...mapGetters('company', ['getConfig', 'getCompanyName']),
    ...mapGetters('insightLayouts', ['getCompanyInsightLayout']),
    ...mapGetters("reasonTrees", ['getReasonTrees']),
    ...mapGetters("insights", ['getEditing']),
    formattedTime() {
      return moment(this.getTime).format('DD-MM HH:mm:ss')
    },
    getLayout() {
      if (this.view === 'company') {
        return this.getCompanyInsightLayout
      }
      if (this.view === 'personal') {
        return this.getMe.insightsLayout ? JSON.parse(this.getMe.insightsLayout) : []
      }
      return []
    }

  },
  methods: {
    async setEditingMode() {
      if (this.editing === true && this.dataChanged) {
        let res = await this.$swal({
          title: this.$root.$t('insights.saveModal'),
          text: this.$root.$t('insights.saveModalText'),
          confirmButtonText: this.$root.$t('ui.save'),
          cancelButtonText: this.$root.$t('ui.cancel'),
          showCancelButton: true
        })
        if (res.isConfirmed) {
          this.saveLayout()
        }
      }
      this.editing = !this.editing
    },
    setItemComponent(e, index) {
      this.layout.splice(index, 1, { ...this.layout[index], component: e.target.value })
    },
    saveComponentConfig(event, layoutIndentifier) {
      let indexForLayout = _.findIndex(this.layout, layout => {
        return layout.i === layoutIndentifier
      })
      this.layout.splice(indexForLayout, 1, { ...this.layout[indexForLayout], config: event })
      if (this.editing === true) {
        this.dataChanged = true
      }
    },
    saveLayout() {
      let module = this.view === 'company' ? 'insightLayouts' : 'userData';
      this.$store.dispatch(`${module}/patch`, {insightsLayout: JSON.stringify(this.layout)}).then(res => {
        this.swalToastSuccess(this.$t('ui.saved'))
        this.dataChanged = false
      })
    },
    removeItem: function (val) {
      const index = this.layout.map(item => item.i).indexOf(val);
      this.layout.splice(index, 1);
      this.saveLayout()
    },
    duplicateItem(item) {
      let layout = _.clone(this.layout[item])
      layout.i = this.layout.length + 1
      layout.x = (this.layout.length * 2) % (this.colNum || 12),
          layout.y = this.layout.length + (this.colNum || 12), // puts it at the bottom

          this.layout.push(layout)

    },
    async addNewGridItem() {
      let inputOptions = {
        [this.$root.$t('menu.jobs')]: {
          Planning: this.$root.$t('insights.addModal.options.planning'),
          JobsFilterBy: this.$root.$t('insights.addModal.options.jobsFilterBy'),
          JobProgress: this.$root.$t('insights.addModal.options.jobProgress'),
          ProducedPerActivity: this.$root.$t('insights.addModal.options.ProducedPerActivity')
        }
      }
      if (this.getConfig.booleansToCount && this.getConfig.booleansToCount.length) {
        inputOptions[this.$root.$t('menu.jobs')]['BooleanCount'] = this.$root.$t('insights.addModal.options.booleanCount')
      }
      if (this.getConfig.datePropertiesToCount && this.getConfig.datePropertiesToCount.length) {
        inputOptions[this.$root.$t('menu.jobs')]['CustomDateChart'] = this.$root.$t('insights.addModal.options.customDateChart')
      }
      if (_.some(this.getReasonTrees, rt => {
        return rt.type == 'job'
      })) {
        inputOptions[this.$root.$t('menu.jobs')]['JobLogs'] = this.$root.$t('insights.addModal.options.jobLogs')
      }
      if (this.getConfig.downTime.enabled) {
        inputOptions[this.$root.$t('menu.downTimes')] = {}
        inputOptions[this.$root.$t('menu.downTimes')]['DownTimePareto'] = this.$root.$t('insights.addModal.options.downTimePareto')
        inputOptions[this.$root.$t('menu.downTimes')]['DownTimeFilterdOnReason'] = this.$root.$t('insights.addModal.options.downTimeFilterBy')
      }
      if (this.getConfig.hasHardwareCounter) {
        inputOptions[this.$root.$t('menu.heartbeat')] = {}
        inputOptions[this.$root.$t('menu.heartbeat')]['HeartbeatHardwareLogs'] = this.$root.$t('insights.addModal.options.HeartbeatHardwareLogs')

      }
      const {value: chart} = await this.$swal.fire({
        title: this.$root.$t('insights.addModal.title'),
        input: 'select',
        width: '80%',
        inputOptions,
        inputPlaceholder: this.$root.$t('insights.addModal.selectBoxTitle'),
        showCancelButton: true,
        inputValidator: (value) => {
          return new Promise((resolve) => {
            resolve()
          })
        }
      })

      if (chart) {
        let newX = _.sumBy(this.layout, 'w') / (this.colNum || 12)
        // if newX is smaller than or === 1.5 it can be added to current row else add +!
        let newY = 0

        if (newX <= 1) {
          newY = Math.floor(newX)
        } else {
          newY = Math.ceil(newX)
        }

        let highestNumberOfIndex = _.maxBy(this.layout, function (o) {
          return o.i;
        });
        let highestNumberOfYPosition = _.maxBy(this.layout, function (o) {
          return o.y;
        });

        this.layout.push({
          x: newX,
          // x: Math.floor((_.sumBy(this.layout,'x')) / (this.colNum || 12)),
          y: highestNumberOfYPosition ? highestNumberOfYPosition.y + highestNumberOfYPosition.h : 0, // newY, // puts it at the bottom
          w: 12,
          h: 10,
          i: highestNumberOfIndex ? highestNumberOfIndex.i + 1 : 0,
          component: chart
        });
        // let myDiv = document.getElementsByClassName("vue-grid-layout")[0];
        setTimeout(() => {
          let scrollingElement = (document.scrollingElement || document.body);
          $(scrollingElement).animate({scrollTop: scrollingElement.scrollHeight}, 750);
        }, 300)

      }
    },

  },
  watch: {
    async editing(newV, oldV) {

    },
    async view(newView) {
      if (newView === 'company') {
        this.layout = this.getCompanyInsightLayout
      }
      if (newView === 'personal') {
        this.layout = this.getMe.insightsLayout ? JSON.parse(this.getMe.insightsLayout) : []
      }
    },
    async 'getCompanyInsightLayout'(newV) {
      this.layout = newV
    },
    async 'getMe.insightsLayout'(newV, oldV) {
      if (this.view === 'personal') {
        this.layout = JSON.parse(this.getMe.insightsLayout)
        if (!this.layout.length) {
          setTimeout(() => {
            this.addNewGridItem()
            this.editing = true
          }, 500)
        }
      }
    }
  },
  created() {
    try {
      this.layout = this.getCompanyInsightLayout;
    } catch (e) {
      console.log('config was not loaded')
    }
  }
}
</script>

<style lang="scss">
.component-selector {
  -webkit-transform: translateX(0) translateY(100%);
  transform: translateX(0) translateY(100%)

}

.vue-grid-item.vue-grid-placeholder {
  background: #6dceec !important;
  opacity: 0.2;
  transition-duration: 100ms;
  z-index: 2;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.vue-grid-item {
  position: relative;
  padding: 10px;
  //padding: 20px 10px 100px; // top sides bottom
  background: #ffffff !important;


}

.vue-draggable-dragging {
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.4) !important;

}

.vue-grid-placeholder {
  background: blue !important;
  opacity: 0.2;
  transition-duration: 100ms;
  z-index: 2;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

/*************************************/
.remove {
  z-index: 1000000;
  position: absolute;
  right: 15px;
  top: 10px;
  height: 10px;
  width: 10px;
  color: #ea5858;
  font-weight: 700;
  cursor: pointer;
}


.edit-header {
  background: white;
  //margin: 10px;
  padding: 10px;
}

.nav-item {
  font-weight: 500;
  border-bottom: 3px transparent;

  &.active {
    transition: border-bottom-color linear 300ms;
    border-bottom: 3px solid #00c9ff;
  }

  &:hover {
    border-bottom: 3px solid rgba(0, 201, 255, 0.20);
  }
}

</style>